import React from "react";

import { cn } from "@/utils/helpers/classnames";

interface ParagraphProps extends React.HTMLAttributes<HTMLParagraphElement> {
  children?: React.ReactNode;
  className?: string;
}

const Paragraph: React.FC<ParagraphProps> = ({ children, className = "", ...props }) => {
  const sizeClasses = "text-sm xl:text-base";

  return (
    <p {...props} className={cn(`font-inter ${sizeClasses} text-text-primary ${className}`)}>
      {children}
    </p>
  );
};

export default Paragraph;
